/* eslint-disable @typescript-eslint/no-explicit-any */
import { Combobox, Field, Option, Skeleton, SkeletonItem, makeStyles, tokens } from '@fluentui/react-components';

export default function CheckListForm(props: {
  validation: string;
  value: string;
	selectedOptions: string[];
  changeSelectOptions(value: string): void;
  changeTextValue(value: string): void;
  options: { label: string; value: string }[];
	loading: boolean;
}) {
	const classes = useStyles();

	if (props.loading) {
		return (
			<Skeleton className={classes.skeletonRoot}>
				<SkeletonItem className={classes.skeletonItem} />
			</Skeleton>
		);
	}

	return (
		<div className={classes.root}>
			<Field
				className={classes.fieldRoot}
				validationMessage={props.validation}
			>
				<Combobox
					className={classes.dropdown}
					autoComplete='off'
					appearance='outline'
					placeholder='Choose a field'
					positioning='below-start'
					value={props.value}
					selectedOptions={props.selectedOptions}
					onOptionSelect={(_, data) => {
						props.changeSelectOptions(data.optionValue as string);
					}}
					onChange={(ev) => {
						props.changeTextValue(ev.target.value);
					}}
				>
					{!props.options.length && (
						<Option value="no-options" disabled>No options</Option>
					)}
					{props.options.map((item) => (
						<Option key={item.value} value={item.value}>
							{item.label}
						</Option>
					))}
				</Combobox>
			</Field>
		</div>
	);
}

export const useStyles = makeStyles({
	root: {
		width: '100%',
		display: 'flex',
	},
	fieldRoot: {
		width: '100%'
	},
	dropdown: {
		flex: '1 1 0px',
		minWidth: '120px',
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		'::after': {
			borderBottom: 'none'
		},
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		},
		':active': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		}
	},
	skeletonRoot: {
		padding: '0px',
	},
	skeletonItem: {
		height: '32px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	}
});